import { getCurrentDomainsNames } from '../../../common/domains';
import { VariableInfo } from '../../../lib/App';
import { ActionType } from '../../../store/actionTypes';
import {
  createApiRequestAction,
  pageToCollectionParams,
} from '../../../store/helpers';
import { variable as variableSchema } from '../../../store/schema';
import { AppDispatch, AppState, Service } from '../../../store/types';
import { alphabeticalSort } from '../../../utils/string';
import { isRequiredToFetch } from '../shared/collection';
import { FetchVariableParams } from './common';
import { variableSelector, variablesViewSelector } from './selectors';
import { parseObjectToParams } from '@/utils/url';

export const VARIABLE_PAGE_SIZE = 20;

export function fetchVariableForLookup(searchString: string) {
  const params: FetchVariableParams = { name: searchString, state: 'inuse' };
  return fetchVariablePage(params, 1);
}

export function fetchVariablePage(params: FetchVariableParams, page: number) {
  return (dispatch: AppDispatch, getState: () => AppState) => {
    const variableView = variablesViewSelector(getState());
    const query = parseObjectToParams(params, {
      sort: alphabeticalSort,
    });
    const collectionParams = pageToCollectionParams(page, VARIABLE_PAGE_SIZE);
    const domains = getCurrentDomainsNames();

    if (isRequiredToFetch(variableView, query, page)) {
      dispatch(
        createApiRequestAction(ActionType.FETCH_VARIABLE_LIST_REQUESTED, {
          request: {
            method: 'GET',
            service: Service.PLANNER,
            url: '/v2/variables/',
            queryParams: {
              domain: domains,
              ...params,
              ...collectionParams,
            },
            normalizr: {
              key: 'items',
              schema: [variableSchema],
            },
            responseTypes: {
              started: ActionType.FETCH_VARIABLE_LIST_STARTED,
              succeeded: ActionType.FETCH_VARIABLE_LIST_SUCCEEDED,
              failed: ActionType.FETCH_VARIABLE_LIST_FAILED,
            },
          },
          query,
          page,
        }),
      );
    }
  };
}

export function fetchVariable(variableName: string) {
  return (dispatch: AppDispatch, getState: () => AppState) => {
    const variable = variableSelector(getState(), variableName);
    if (!variable) {
      return dispatch(
        createApiRequestAction(ActionType.FETCH_VARIABLE_REQUESTED, {
          request: {
            method: 'GET',
            service: Service.PLANNER,
            url: `/v2/variables/${variableName}/`,
            normalizr: {
              schema: variableSchema,
            },
            responseTypes: {
              started: ActionType.FETCH_VARIABLE_STARTED,
              succeeded: ActionType.FETCH_VARIABLE_SUCCEEDED,
              failed: ActionType.FETCH_VARIABLE_FAILED,
            },
          },
        }),
      );
    }
  };
}

export const createVariable = (variable: VariableInfo) =>
  createApiRequestAction(ActionType.CREATE_VARIABLES_REQUESTED, {
    request: {
      method: 'POST',
      service: Service.PLANNER,
      url: '/v2/variables/',
      body: { ...variable },
      normalizr: {
        schema: variableSchema,
      },
      responseTypes: {
        started: ActionType.CREATE_VARIABLES_STARTED,
        succeeded: ActionType.CREATE_VARIABLES_SUCCEEDED,
        failed: ActionType.CREATE_EXPERIMENT_FAILED,
      },
    },
  });

export const updateVariable = (variable: VariableInfo) =>
  createApiRequestAction(ActionType.UPDATE_VARIABLES_REQUESTED, {
    request: {
      method: 'PUT',
      service: Service.PLANNER,
      url: '/v2/variables/',
      body: { ...variable },
      normalizr: {
        schema: variableSchema,
      },
      responseTypes: {
        started: ActionType.UPDATE_VARIABLES_STARTED,
        succeeded: ActionType.UPDATE_VARIABLES_SUCCEEDED,
        failed: ActionType.UPDATE_VARIABLES_FAILED,
      },
    },
  });
